/**
 * Statuspage.io scheduled maintenance incidents
 */
import _ from 'underscore';
import Backbone from 'backbone';

    var scheduled_maintenance = new Backbone.Collection();
    _.extend(scheduled_maintenance, {
        url: 'https://electricimp.statuspage.io/api/v2/scheduled-maintenances.json',
        parse: function(resp) {
            return _(resp.scheduled_maintenances).filter(function(item) {
                return item.status !== 'completed';
            });
        },
        fetch: function(options) {
            if (!options) options = {};
            var existingSuccessCallback = options.success;
            options.success = function(collection, response, options) {
                if (existingSuccessCallback) {
                    existingSuccessCallback.call(this, collection, response, options);
                }
            };
            Backbone.Collection.prototype.fetch.call(this, options);
        },
        type: 'scheduled_maintenance'
    });
    export default scheduled_maintenance;

